import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sendConversationImage } from '@/api/conversations';
import type { EnviarImagenRequest } from '@/types/conversations';
import { invalidateAfterSend, patchMessagesCache } from './inbox-cache';

/**
 * Respuesta MANUAL del asesor desde el panel (módulo 5) — **foto**.
 *
 * Mismo contrato y mismos permisos que el texto (`useSendMessage`), y las mismas dos reglas de caché
 * (ver `inbox-cache.ts`). Lo propio de la foto:
 *  - el binario ya viene **preparado por el composer** (validado y reescalado en el navegador): acá
 *    solo viaja en base64, porque el proyecto no tiene parser de multipart;
 *  - el backend la guarda en `uploads/chat/` y la manda por su **URL pública**, así que un **400**
 *    aquí suele significar `PUBLIC_BASE_URL` sin configurar (el aviso del backend lo dice tal cual);
 *  - si el canal no la entrega, el backend responde **502 y borra el archivo**: no queda ni fila en el
 *    historial ni archivo huérfano, así que el asesor puede reintentar sin duplicar nada.
 */

export interface SendImageInput {
  conversationId: string;
  imagen: EnviarImagenRequest;
}

export function useSendImage(tenantId: string | null, conversationId: string | null) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ conversationId: id, imagen }: SendImageInput) =>
      sendConversationImage(tenantId ?? '', id, imagen),

    onSuccess: (mensaje, variables) => {
      if (!tenantId) return;

      patchMessagesCache(queryClient, tenantId, variables.conversationId, mensaje);
      invalidateAfterSend(queryClient, tenantId, variables.conversationId);
    },
  });
}